import { toast } from "sonner";

export const infoToast = (msg: string) => toast.success(msg.toString());
export const errorToast = (msg: string) => toast.error(msg.toString());
export const successToast = (msg: string) => toast.success(msg.toString());
